const initTabbedMenu = () => {
  const tabbedMenuSection = document.querySelector('[data-tabbed-menu]');
  if (!tabbedMenuSection) return;

  const selectEls = document.querySelectorAll('[data-tabbed-menu-select]');
  if (!selectEls.length) return;

  selectEls.forEach((selectEl) => {
    selectEl.addEventListener('change', () => {
      window.location.href = selectEl.value;
    });
  });
};

export default initTabbedMenu;
